<template>
  <div class="not_found">
    <h1 class="code">404</h1>
    <h1 class="message text-main">{{ $t('home.pageNotFound') }}</h1>
    <div>
        <a href="/" class="btn g-primary-button mt-3">{{  $t('home.backToHome') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "404",
};
</script>

<style scoped>
.not_found {
    text-transform: uppercase;
    margin: 150px 0;
    text-align: center;
}
.not_found h1 {
    font-weight: bolder;
}

.not_found .message {
    font-size: 30px;
}

.not_found .code {
    font-size: 85px;
}
</style>